/**
 * Разбор ширины колонки из конфигурации/схемы — единый для всех потребителей
 * (таблицы форм, схемные списки, пикеры): px-число даёт точный трек,
 * «60%»/«12vw» — пропорцию гибкого трека (fr-вес), см. TABLEDATA-NEXT.md.
 */

export type DataTableConfigColumnWidth = string | number | null | undefined;

export interface IDataTableParsedColumnSizing {
    width?: number;
    flexWeight?: number;
}

const parsePositiveValue = (raw: string): number | undefined => {
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : undefined;
};

/** Ширина конфигурации: px-число даёт фиксированный трек; vw/%/пустая — flex-колонка
 *  (у DataTable flex-колонки делят остаток; парсить «100%» как 100px нельзя —
 *  колонки схлопывались в минимум). */
export function parseColumnWidth(width: DataTableConfigColumnWidth): number | undefined {
    if (width == null || width === '') return undefined;
    const raw = String(width).trim().toLowerCase();
    return parsePositiveValue(raw.endsWith('px') ? raw.slice(0, -2).trim() : raw);
}

/** Пропорция flex-колонки: «60%»/«12vw» → fr-вес 60/12 (60% против 30% = доля 2:1),
 *  прочие ширины веса не дают (доли равны). */
export function parseColumnFlexWeight(width: DataTableConfigColumnWidth): number | undefined {
    if (width == null || width === '') return undefined;
    const raw = String(width).trim().toLowerCase();
    if (raw.endsWith('%')) return parsePositiveValue(raw.slice(0, -1).trim());
    if (raw.endsWith('vw')) return parsePositiveValue(raw.slice(0, -2).trim());
    return undefined;
}

/** Атомарное преобразование конфигурационной ширины в контракт DataTable. */
export function parseColumnSizing(width: DataTableConfigColumnWidth): IDataTableParsedColumnSizing {
    return {
        width: parseColumnWidth(width),
        flexWeight: parseColumnFlexWeight(width),
    };
}
